"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactRedux = require("react-redux");

var _prospectingContacts = require("../../../../constants/prospectingContacts.schemas");

var _CountriesPicker = require("../../../../../../../Shared/components/CountriesPicker");

var _commonData = require("../../../../../../../Shared/store/commonData/commonData.selector");

var _StyledFieldSkeleton = require("./StyledFieldSkeleton");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      zIndex = _ref.zIndex;
  return {
    helperText: {
      margin: 0
    },
    popper: {
      zIndex: zIndex.modal,
      minWidth: 220,
      maxWidth: 220
    },
    countryValueLabel: {
      color: palette.text.primary
    }
  };
});

var CountryCell = function CountryCell(_ref2) {
  var rowIndex = _ref2.rowIndex,
      columnData = _ref2.columnData,
      rowData = _ref2.rowData,
      countries = _ref2.countries;
  var classes = useStyles();
  var name = "".concat(_prospectingContacts.ContactStepField.contacts, ".").concat(rowIndex, ".").concat(_prospectingContacts.ContactField.country);

  var _useController = (0, _reactHookForm.useController)({
    control: columnData === null || columnData === void 0 ? void 0 : columnData.control,
    name
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      _onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var countryValue = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _commonData.makeGetCountryByCode)(value, null);
  }, [value]));
  var hasError = Boolean(error === null || error === void 0 ? void 0 : error.message);
  return rowData !== null && rowData !== void 0 && rowData.id ? /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: hasError,
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_CountriesPicker.CountriesPicker, {
    label: "Country",
    searchLabel: "Search countries",
    name: name,
    value: countryValue,
    onChange: function onChange(country) {
      if (country) {
        _onChange(country.code);
      }
    },
    options: countries,
    multiple: false,
    classes: {
      popper: classes.popper,
      valueLabel: classes.countryValueLabel
    },
    buttonIconProps: {
      fontSize: 0.8
    },
    PopperProps: {
      disablePortal: false
    },
    disabled: columnData === null || columnData === void 0 ? void 0 : columnData.isLoading
  }), hasError && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    classes: {
      contained: classes.helperText
    }
  }, error === null || error === void 0 ? void 0 : error.message)) : /*#__PURE__*/_react.default.createElement(_StyledFieldSkeleton.StyledFieldSkeleton, {
    variant: "rect",
    width: "100%",
    height: 48
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(CountryCell);

exports.default = _default;